import { ReactComponent as SvgMegaphone } from '../../../assets/icons/Megaphone.svg.js';
import { createIconComponent } from './createIconComponent.js';

var MegaphoneIcon = createIconComponent(SvgMegaphone);

export { MegaphoneIcon };
//# sourceMappingURL=MegaphoneIcon.js.map
